import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { cn } from '@shared/utils/utils';

@Component({
  selector: 'button[appButton]',
  template: `<ng-content />`,
  host: { '[class]': 'classes()' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonComponent {
  variant = input<'default' | 'outline' | 'ghost' | 'destructive'>('default');
  size = input<'sm' | 'md' | 'lg'>('md');

  readonly classes = computed(() => {
    const size = this.size();
    const variant = this.variant();
    let sizeClass: string;
    if (size === 'sm') {
      sizeClass = 'h-8 px-3 text-sm gap-1.5';
    } else if (size === 'lg') {
      sizeClass = 'h-11 px-8 text-base gap-2';
    } else {
      sizeClass = 'h-9 px-4 text-sm gap-2';
    }
    let variantClass: string;
    if (variant === 'default') {
      variantClass = 'bg-primary text-white hover:bg-primary/90';
    } else if (variant === 'outline') {
      variantClass = 'border border-border bg-transparent hover:bg-muted/10 text-primary';
    } else if (variant === 'ghost') {
      variantClass = 'bg-transparent hover:bg-muted/10 text-primary';
    } else {
      variantClass = 'bg-destructive text-white hover:bg-destructive/90';
    }
    return cn(
      'inline-flex items-center justify-center rounded-md font-medium transition-colors cursor-pointer',
      'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-primary',
      'disabled:pointer-events-none disabled:opacity-50',
      sizeClass,
      variantClass,
    );
  });
}
